export default "__VITE_ASSET__DSB9rdK5__"